import { use, useEffect, useRef, useState } from "react";
import { Col, Row, Table } from "react-bootstrap";
import { loader } from "../../../loader";
import { useNavigate, useLocation } from "react-router-dom";
import { getData, postData } from "../../../axios/apiHelper";
import { Tooltip, OverlayTrigger } from "react-bootstrap";
import html2canvas from "html2canvas";
import domtoimage from "dom-to-image-more";
import axios from "../../../axios/index";
import { saveAs } from "file-saver";
import ContentEngagement from "../Common/ContentEngagement";
import ContentDistribution from "../Common/ContentDistribution";
import { Link } from "react-router-dom";
import TopEngagement from "../Common/TopEngagement";
export default function ViewVwdProfile() {
  let path_image = process.env.REACT_APP_ASSETS_PATH_INFORMED_DESIGN;
  const [handleFullDownload, setHandleFullDownload] = useState(false);
  const [analyticsData, setAnalyticsData] = useState(null);
  const [topEngagementData, setTopEngagementData] = useState(null);
  const [selectedMode, setSelectedMode] = useState("total");
  const [isSummaryDownloading, setIsSummaryDownloading] = useState(false);
  const profileApiInFlightRef = useRef(0);
  const navigate = useNavigate();
  const location = useLocation();
  const state = location?.state || {};

  const [userId, setUserId] = useState(state?.id ?? "");
    const [userUniqueId, setUserUniqueId] = useState(state?.user_id ?? "");
  const [userData, setUserData] = useState({});
  const lastLogin = userData?.lastLogin || "";
 const [value, unit] = lastLogin.split(" ");

  const startProfileApiLoading = () => {
    profileApiInFlightRef.current += 1;
    loader("show");
  };

  const stopProfileApiLoading = () => {
    profileApiInFlightRef.current = Math.max(profileApiInFlightRef.current - 1, 0);
    if (profileApiInFlightRef.current === 0) {
      loader("hide");
    }
  };
  const LinkWithTooltip = ({ id, children, href, tooltip }) => {
    return (
      <OverlayTrigger
        overlay={<Tooltip id={id}>{tooltip}</Tooltip>}
        placement="top"
        delayShow={300}
        delayHide={150}
      >
        <a href={href}>{children}</a>
      </OverlayTrigger>
    );
  };

  const handleFullScreenPrint = async (element, fileName) => {
    try {
      loader("show");

      // Wait for all fonts to be loaded
      if (document.fonts && document.fonts.ready) {
        await document.fonts.ready;
      }

      // const printBtn = element.querySelector(".inner-print-btn");
      // if (printBtn) {
      //   printBtn.style.display = "none"
      // }

      // Store original background
      const originalBackground = element.style.backgroundColor;
      if (
        fileName === "User-details" ||
        fileName === "Topic-details" ||
        fileName === "user-engagements"
      ) {
        // element.style.backgroundColor = "#ffffff";
        // Find all tables in this section and set their border colors to white
        const tables = element.querySelectorAll("table");
        tables.forEach((table) => {
          table.style.borderColor = "#ffffff";
        });
        // Also set table cell border colors to white
        const tableCells = element.querySelectorAll("td, th");
        tableCells.forEach((cell) => {
          cell.style.borderColor = "#ffffff";
        });
      }

      if (
        fileName === "Overview-details" ||
        fileName === "All-engagements" ||
        fileName === "user-engagements"
      ) {
        const canvas = await html2canvas(element, {
          useCORS: true,
          scale: 2,
        });
        const dataUrl = canvas.toDataURL("image/png");
        const link = document.createElement("a");
        link.download = `${fileName}.png`;
        link.href = dataUrl;
        link.click();
      } else {
        console.log(element);
        await domtoimage
          .toPng(element, {
            bgcolor: "#ffffff",
            filter: (node) => node.tagName !== "LINK",
          })
          .then(function (dataUrl) {
            var link = document.createElement("a");
            link.download = `${fileName}.png`;
            link.href = dataUrl;
            link.click();
          });
      }

      // Restore original background
      element.style.backgroundColor = originalBackground;

      // if (printBtn) {
      //   printBtn.style.display = "block"
      // }
      loader("hide");
    } catch (err) {
      loader("hide");
      console.error("Error while printing section:", err);
    }
  };

  const handleSingleDivPrint = async (element, fileName) => {
    try {
      loader("show");

      // Wait for all fonts to be loaded
      if (document.fonts && document.fonts.ready) {
        await document.fonts.ready;
      }

      const printBtn = element.querySelector(".inner-print-btn");
      if (printBtn) {
        printBtn.style.display = "none";
      }

      // Store original background
      const originalBackground = element.style.backgroundColor;
      if (
        fileName === "User-details" ||
        fileName === "Topic-details" ||
        fileName === "user-engagements"
      ) {
        // element.style.backgroundColor = "#ffffff";
        // Find all tables in this section and set their border colors to white
        const tables = element.querySelectorAll("table");
        tables.forEach((table) => {
          table.style.borderColor = "#ffffff";
        });
        // Also set table cell border colors to white
        const tableCells = element.querySelectorAll("td, th");
        tableCells.forEach((cell) => {
          cell.style.borderColor = "#ffffff";
        });
      }

      if (fileName === "Overview-details" || fileName === "All-engagements") {
        const canvas = await html2canvas(element, {
          useCORS: true,
          scale: 2,
        });
        const dataUrl = canvas.toDataURL("image/png");
        const link = document.createElement("a");
        link.download = `${fileName}.png`;
        link.href = dataUrl;
        link.click();
      } else {
        await domtoimage
          .toPng(element, {
            bgcolor: "#ffffff",
          })
          .then(function (dataUrl) {
            var link = document.createElement("a");
            link.download = `${fileName}.png`;
            link.href = dataUrl;
            link.click();
          });
      }

      // Restore original background
      element.style.backgroundColor = originalBackground;

      if (printBtn) {
        printBtn.style.display = "block";
      }
      loader("hide");
    } catch (err) {
      loader("hide");
      console.error("Error while printing section:", err);
    }
  };

  useEffect(() => {
    const getUserInfo = async () => {
      try {
        startProfileApiLoading();
        const body = { user_id: userId };
        const res = await postData("/narrative/get-user-information", body);
        if (res?.status == 200) {
          const profileData = res.data.data?.[0] || {};
          setUserData(profileData);
          if (!userUniqueId && profileData?.user_id) {
            setUserUniqueId(profileData.user_id);
          }
        }
      } catch (err) {
        console.log("Error while fetching user info:", err);
      } finally {
        stopProfileApiLoading();
      }
    };
    if (userId) getUserInfo();
  }, [userId, userUniqueId]);

  useEffect(() => {
    const getBaseUserAnalytics = async () => {
      try {
        startProfileApiLoading();
        const response = await getData(`/narrative/get-unmet-analytics?id=${userId}&user_id=${userUniqueId}`);
        if (response.status === 200) {
          setAnalyticsData(response.data?.data);
          setTopEngagementData(response.data?.data?.analyticsData || null);
        }
      } catch (err) {
        console.log("Error while fetching base user analytics:", err);
      } finally {
        stopProfileApiLoading();
      }
    };
    if (userId) getBaseUserAnalytics();
  }, [userId]);

  useEffect(() => {
    const getTopEngagementByMode = async () => {
      try {
        startProfileApiLoading();
        const response = await getData(
          `/narrative/get-unmet-analytics?id=${userId}&mode=${selectedMode}&user_id=${userUniqueId}`,
        );
        if (response.status === 200) {
          setTopEngagementData(response.data?.data?.analyticsData || null);
        }
      } catch (err) {
        console.log("Error while fetching top engagement data:", err);
      } finally {
        stopProfileApiLoading();
      }
    };
    if (userId) getTopEngagementByMode();
  }, [selectedMode, userId]);

  const handleDownloadSummary = async () => {
    if (!userId) return;
    try {
      setIsSummaryDownloading(true);
      loader("show");
      const response = await axios.get(
        `/narrative/download-unmet-summary?scope=profile&id=${userId}`,
        { responseType: "blob" },
      );
      const excelBlob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      saveAs(
        excelBlob,
        `vwd_profile_summary_${userId}_${new Date().toISOString().slice(0, 10)}.xlsx`,
      );
    } catch (error) {
      console.error("Error downloading profile summary excel:", error);
    } finally {
      loader("hide");
      setIsSummaryDownloading(false);
    }
  };
  const userstatus = {
    "Access Requested": "access",
    "Active": "active",
    "Rejected": "rejected",
    "Blocked": "blocked",
    "Deleted": "deleted",
    "Invited": "invite",
  };
  const statusTooltip = {
  "Access Requested": "User has requested access to the platform and is awaiting approval",
  "Active": "User who currently has access to the platform",
  "Rejected": "User's access request was reviewed and not approved",
  "Blocked": "User whose access to the platform has been restricted",
  "Deleted": "User account has been removed from the platform",
  "Invited": "User who has received an invitation to access the platform but has not logged in yet",
};
  return (
    <>
      <Col className="right-sidebar custom-change vwd-profile-analytics">
        <div className="custom-container">
          <Row>
            <div className="top-header profile_header sticky">
              <div className="page-title d-flex align-items-start">
                <div class="back-link">
                  <Link to="/vwd/profile" class="btn btn-primary btn-bordered back-btn me-2" data-discover="true">
                    <svg width="14" height="24" viewBox="0 0 14 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M0.159662 12.0019C0.159662 11.5718 0.323895 11.1417 0.65167 10.8138L10.9712 0.494292C11.6277 -0.16216 12.692 -0.16216 13.3482 0.494292C14.0044 1.15048 14.0044 2.21459 13.3482 2.8711L4.21687 12.0019L13.3479 21.1327C14.0041 21.7892 14.0041 22.8532 13.3479 23.5093C12.6917 24.1661 11.6274 24.1661 10.9709 23.5093L0.65135 13.19C0.323523 12.8619 0.159662 12.4319 0.159662 12.0019Z" fill="#70899E"></path>
                    </svg>
                  </Link>
                </div>
                <div className="d-flex flex-column">
                  <h2 className="d-flex align-items-center gap-1">Profile</h2>
                  <p className="d-flex align-items-center p-0">April. 22. 2024</p>
                </div>
              </div>

            <div className="top-right-action">
              <div class="action-btn-add">
                <button
                  type="button"
                  class="btn-filled btn-downloaded   btn btn-primary"
                  onClick={handleDownloadSummary}
                  disabled={isSummaryDownloading}
                >
                  Summary (Excel)
                  <img
                    src="https://informed.pro/componentAssets/images/download.svg"
                    alt="icon"
                  />
                </button>
              </div>
              <div class="action-btn-add">
                <button
                  type="button"
                  class="btn-white btn-capture    btn btn-primary"
                  onClick={() =>
                    handleFullScreenPrint(
                      document.getElementById("whole-screen"),
                      "user-engagements",
                    )
                  }
                >
                  <svg
                    id="Layer_1"
                    data-name="Layer 1"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 512 512"
                    height="24px"
                    width="24px"
                  >
                    <path
                      d="M42.653,170.667A21.333,21.333,0,0,1,21.32,149.333V85.32a64.073,64.073,0,0,1,64-64h64.014a21.333,21.333,0,1,1,0,42.667H85.32A21.357,21.357,0,0,0,63.986,85.32v64.014A21.333,21.333,0,0,1,42.653,170.667Z"
                      fill="#0066be"
                    ></path>
                    <path
                      d="M426.68,490.68H362.667a21.333,21.333,0,1,1,0-42.667H426.68a21.357,21.357,0,0,0,21.333-21.333V362.667a21.333,21.333,0,1,1,42.667,0V426.68A64.073,64.073,0,0,1,426.68,490.68Z"
                      fill="#0066be"
                    ></path>
                    <path
                      d="M448,170.667a21.333,21.333,0,0,1-21.333-21.333V85.32a21.357,21.357,0,0,0-21.333-21.333H341.32a21.333,21.333,0,1,1,0-42.667h64.014a64.073,64.073,0,0,1,64,64v64.014A21.333,21.333,0,0,1,448,170.667Z"
                      fill="#0066be"
                    ></path>
                    <path
                      d="M149.333,490.68H85.32a64.073,64.073,0,0,1-64-64V362.667a21.333,21.333,0,1,1,42.667,0V426.68A21.357,21.357,0,0,0,85.32,448.014h64.014a21.333,21.333,0,1,1,0,42.667Z"
                      fill="#0066be"
                    ></path>
                    <path
                      d="M362.68,384.014H149.32a42.716,42.716,0,0,1-42.667-42.667V213.32a42.716,42.716,0,0,1,42.667-42.667h29.5l15.436-30.874a21.334,21.334,0,0,1,19.081-11.793h85.333a21.334,21.334,0,0,1,19.081,11.793l15.436,30.874h29.5a42.716,42.716,0,0,1,42.667,42.667V341.347A42.716,42.716,0,0,1,362.68,384.014ZM149.32,213.32V341.347H362.68V213.32H320a21.334,21.334,0,0,1-19.081-11.793l-15.436-30.874H226.518l-15.436,30.874A21.334,21.334,0,0,1,192,213.32Z"
                      fill="#0066be"
                    ></path>
                    <path
                      d="M256,330.667a64,64,0,1,1,64-64A64.073,64.073,0,0,1,256,330.667Zm0-85.333a21.333,21.333,0,1,0,21.333,21.333A21.357,21.357,0,0,0,256,245.333Z"
                      fill="#0066BE"
                    ></path>
                  </svg>
                </button>
              </div>
            </div>
            </div>

            {/* GENERAL INFO */}
            <div className="profile-general-info reader-profile-viewer" id="whole-screen">
              <Row>
                {/* GENERAL INFO */}
                <Col className="hcp-info">
                  <div className="general-info">
                    <div className="profile-box-title">
                      <p>General info</p>
                    </div>

                    <div className="hcp-profile-view">
                      <div className="hcp-general-info">
                        <p>
                          {userData?.name || "N/A"}
                          {userData?.ibt === 1 && (
                            <img
                              src={path_image + "ibt-badge.png"}
                              alt="ibt-badge"
                              style={{
                                width: "32px",
                                height: "36px",
                              }}
                            />
                          )}
                        </p>
                        <Table>
                          <tbody>
                            <tr>
                              <th>Email</th>
                              <td>{userData?.email || "N/A"}</td>
                            </tr>
                            <tr>
                              <th>Type</th>
                              <td>{userData?.type || "N/A"}</td>
                            </tr>
                            <tr>
                              <th>Role</th>
                              <td>{userData?.role || "N/A"}</td>
                            </tr>
                            <tr>
                              <th>Company</th>
                              <td>{userData?.company || "N/A"}</td>
                            </tr>
                            <tr>
                              <th>Region</th>
                              <td>{userData?.region || "N/A"}</td>
                            </tr>
                            <tr>
                              <th>Country</th>
                              <td>{userData?.country || "N/A"}</td>
                            </tr>
                            <tr>
                              <th>Status</th>
                              <td className={userstatus[userData?.userStatus]}>
                                {userData?.userStatus}{" "}
                                   <LinkWithTooltip
                                    tooltip={statusTooltip[userData?.userStatus] || "Status not available"}
                                   // href="#"
                                  >
                                    <img
                                       src={path_image + "info_circle_icon.svg"}
                                       alt="info"
                                    />
                                  </LinkWithTooltip>
                              </td>
                            </tr>
                            {/* <tr><th>Join Date</th><td>{userData?.created}</td></tr> */}
                          </tbody>
                        </Table>
                      </div>

                      <div className="hcp-local-intraction">
                        <div className="activity-card">
                          <div className="days-icon-wrap d-flex align-items-center">
                            <img
                              src={path_image + "profile-calendar.svg"}
                              alt="calendar"
                            />
                          </div>

                          <div className="activity-content">
                            <div className="activity-row">
                              <p>Join Date</p>
                              <h5>{userData?.created || "N/A"}</h5>
                            </div>

                            <div className="activity-divider"></div>

                           <div className="activity-row">
                            <p>Days since last activity</p>

                            <h4>
                              {value || "N/A"}{" "}
                              <span>{unit || ""}</span>
                            </h4>
                          </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </Col>

                {/* Mode engagement */}
                <Col className="Mode-engagement">
                  <div className="general-info">
                    <div className="profile-box-title">
                      <p>Mode engagement</p>
                    </div>

                    <div className="hcp-profile-view box topic">
                      {/* Card 1 */}
                      <div className="mode-card total-vwd-card">
                        <p className="mode-title">Total VWD visits</p>
                        <h2 className="mode-value"> {analyticsData?.analyticsData?.totalVisits || "N/A"}</h2>
                      </div>

                      <div className="mode-card">
                        <p className="mode-title octa">Octapharma</p>
                        <h2 className="mode-value light">{analyticsData?.analyticsData?.octaVisits || "N/A"}</h2>
                        <div className="mode-divider"></div>
                        <p className="mode-subtitle">Ave. Session duration</p>
                        <h4 className="mode-time">
                          {
                            analyticsData?.analyticsData
                              ?.avgOctaDuration
                          }{" "}
                          <small>min</small>
                        </h4>
                      </div>

                      <div className="mode-card">
                        <p className="mode-title">HCP</p>
                        <h2 className="mode-value light">{analyticsData?.analyticsData?.hcpVisits || "N/A"}</h2>
                        <div className="mode-divider"></div>
                        <p className="mode-subtitle">Ave. Session duration</p>
                        <h4 className="mode-time light">

                          {
                            analyticsData?.analyticsData
                              ?.avgHcpDuration
                          }{" "}
                          <small>min</small>

                        </h4>
                      </div>
                    </div>
                  </div>
                </Col>

                {/* OVERVIEW */}
                <Col className="overview">
                  <div className="general-info">
                    <div className="profile-box-title">
                      <p>Content Engagement</p>
                    </div>
                    <ContentEngagement
                      data={{
                        line: analyticsData?.analyticsData?.engagement,
                        pie: analyticsData?.analyticsData?.contentEngagement,
                      }}
                      label="latest"
                    />
                  </div>
                </Col>

                {/* Content Distribution*/}
                <Col className="Content-Distribution">
                  <div className="general-info">
                    <div className="profile-box-title">
                      <p>Content Distribution</p>
                    </div>

                    <ContentDistribution
                      data={analyticsData?.analyticsData?.distribution}
                    />
                  </div>
                </Col>
              </Row>

              {/* SECOND ROW */}
              <Row>
                {/* Email */}
                <Col className="Email bottom">
                  <div className="general-info">
                    <div className="profile-box-title">
                      <p>Email</p>
                    </div>

                    <div className="hcp-profile-view box topic">
                      <div className="profile-title d-flex align-items-center justify-content-between">
                        <p>Email engagement</p>
                      </div>

                      <div className="hcp-profile-content">
                        <p className="card-title">In All-Time</p>

                        <div className="email-stats-card">
                          <div className="email-stat-row">
                            <p className="email-label sent">Emails sent</p>
                            <div className="email-value-wrap">
                              <div className="email-icon">
                                <img src={path_image + "email-sent-engagement.svg"} alt="sent" />
                              </div>
                              <h5>{analyticsData?.analyticsData?.emailEngagement?.emailDelivered}</h5>
                            </div>
                          </div>

                          <div className="email-divider"></div>

                          <div className="email-stat-row">
                            <p className="email-label open">Emails opened</p>
                            <div className="email-value-wrap">
                              <div className="email-icon">
                                <img src={path_image + "email-open-engagement.svg"} alt="opened" />
                              </div>
                              <h5>{analyticsData?.analyticsData?.emailEngagement?.emailOpenedPercentage}%</h5>
                            </div>
                          </div>

                          <div className="email-divider"></div>

                          <div className="email-stat-row">
                            <p className="email-label ctr">CTR</p>
                            <div className="email-value-wrap">
                              <div className="email-icon">
                                <img src={path_image + "ctr-engagement.svg"} alt="ctr" />
                              </div>
                              <h5>{analyticsData?.analyticsData?.emailEngagement?.overallTrackCtrLinks}</h5>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </Col>
                {/* All / Female */}
                <Col className="Email bottom">
                  <div className="general-info">
                    <div className="profile-box-title">
                      <p>All / Female</p>
                    </div>

                    <div className="hcp-profile-view box topic">
                      <div className="profile-title">
                        <p className="af-title">All / Female</p>
                      </div>

                      <div className="hcp-profile-content">
                        <p className="card-title">Eng in last 12 months</p>

                        <div className="email-stats-card all-female">
                          {/* All */}
                          <div className="af-row">
                            <p>All</p>
                            <h5 className="dark">
                              {analyticsData?.analyticsData?.allTouchpointsCount || 0}
                            </h5>
                          </div>

                          <div className="email-divider"></div>

                          {/* Female */}
                          <div className="af-row">
                            <p>Female</p>
                            <h5 className="light">
                              {analyticsData?.analyticsData?.allFemaleCount || 0}
                            </h5>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </Col>
                {/* ENGAGEMENTS */}
                <Col className="engagements">
                  <div className="profile-box-title d-flex align-items-center justify-content-between">
                    <p>Top 5 Engagement</p>
                    <div className="engagement-mode-toggle">
                      {[
                        { value: "total", label: "Total" },
                        { value: "octapharma", label: "Octapharma" },
                        { value: "hcp", label: "HCP" },
                      ].map((mode) => (
                        <button
                          key={mode.value}
                          type="button"
                          className={selectedMode === mode.value ? "active" : ""}
                          onClick={() => setSelectedMode(mode.value)}
                        >
                          {mode.label}
                        </button>
                      ))}
                    </div>
                  </div>

                  <TopEngagement type={"profile"}
                    regions={topEngagementData?.topRegions}
                    filters={topEngagementData?.topFilters}
                    contents={topEngagementData?.overAllPdfOpeniing}
                  />
                </Col>
              </Row>
            </div>
          </Row>
        </div>
      </Col>
    </>
  );
}
